import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Input from 'components/shared/Input/Input';
import Select from 'components/shared/Select/Select';

import { findSelectedState } from './helpers';

const BillingAddressInformation = ({ formik, handleSelectState, states, customSelectStyle }) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="mb-4">
        <div className="mb-1 text-base font-500 text-neutral-900">Billing address information</div>
        <p className="text-sm text-neutral-700">
          Please provide the billing address information for this billing provider. This information
          is required to complete billing setup.
        </p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Input
          label="Address"
          type="text"
          placeholder="Address"
          name="bill_addr_1"
          value={formik?.values?.bill_addr_1}
          onChange={formik?.handleChange}
          id="addressFirst"
          required
          error={formik?.touched?.bill_addr_1 && formik?.errors?.bill_addr_1}
        />
        <Input
          label="Address 2"
          type="text"
          placeholder="Address 2"
          name="bill_addr_2"
          value={formik?.values?.bill_addr_2}
          onChange={formik?.handleChange}
          id="addressSecond"
          required
          error={formik?.touched?.bill_addr_2 && formik?.errors?.bill_addr_2}
        />
        <Input
          label="City"
          type="text"
          placeholder="City"
          name="bill_city"
          value={formik?.values?.bill_city}
          onChange={formik?.handleChange}
          required
          error={formik?.touched?.bill_city && formik?.errors?.bill_city}
        />
        <Select
          label="State"
          menuPortalTarget={document.body}
          placeholder="Type and select state"
          value={findSelectedState(states, formik?.values?.bill_state)}
          onChange={(value) => handleSelectState(value)}
          options={states}
          styles={customSelectStyle}
          inputId="state"
          error={formik?.touched?.bill_state && formik?.errors?.bill_state}
          required
        />
        <Input
          label="ZIP Code"
          type="text"
          placeholder="Zip"
          name="bill_zip"
          value={formik?.values?.bill_zip}
          onChange={formik?.handleChange}
          id="zipCode"
          required
          error={formik?.touched?.bill_zip && formik?.errors?.bill_zip}
        />
      </div>
    </div>
  );
};

export default withErrorBoundary(BillingAddressInformation);
